import {
  Component,
  Input
  
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IFormKey } from 'src/app/modules/shared/models/forms';
import { branch_office_variation_form_keys } from './branch-office-variation.constants';
import { Subject } from 'rxjs';
import { LoggerService } from 'src/app/services/logger.service';

@Component({
  selector: 'app-branch-office-variation',
  templateUrl: './branch-office-variation.component.html',
  styleUrl: './branch-office-variation.component.scss',
})
export class BranchOfficeVariationComponent {
  @Input() form: FormGroup;
  @Input() currentBranchOffice: string;

  formKeys: IFormKey[] = branch_office_variation_form_keys;
}
